import 'css-chunksrc/client/pages/projectPage/resourcesPage/resource/tagsList/infoTagsBox/styles.scss';export default {
  "infoTagsBox": "_infoTagsBox_7z5m6_1",
  "name": "_name_7z5m6_10"
};